function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UgandaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_726",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      rx: "-1",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_726)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#FECA00"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_726",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_726)",
      children: [/*#__PURE__*/_jsx("rect", {
        y: "3",
        width: "24",
        height: "3",
        fill: "#272727"
      }), /*#__PURE__*/_jsx("rect", {
        y: "9",
        width: "24",
        height: "3",
        fill: "#D74800"
      }), /*#__PURE__*/_jsx("rect", {
        y: "12",
        width: "24",
        height: "3",
        fill: "#272727"
      }), /*#__PURE__*/_jsx("rect", {
        y: "18",
        width: "24",
        height: "3",
        fill: "#D74800"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2597 9.24648L9.4662 9.50684L10.2597 9.57478C10.2597 9.57478 10.388 9.88854 10.2597 10.1335C10.2271 10.1957 10.1431 10.2753 10.0359 10.377C9.72074 10.6759 9.20497 11.165 9.20497 11.9597C9.20497 13.0247 11.2604 13.5076 11.2604 13.5076V14.0136C11.2604 14.0136 11.4989 14.1618 10.1378 14.1618C8.95745 14.1618 9.03127 14.6099 9.07169 14.8552C9.07787 14.8928 9.08328 14.9256 9.08328 14.9513C9.08328 15.1449 9.65061 14.7576 9.91619 14.372C10.056 14.169 10.6414 14.1797 11.2422 14.2354C11.2897 14.2398 11.7278 15.1678 11.3474 15.6472C11.1877 15.8486 10.6359 15.8748 10.2912 15.8912C10.1154 15.8996 9.99346 15.9054 10.0048 15.9305C10.0133 15.9494 10.1172 15.9432 10.2683 15.9342C10.4569 15.9229 10.719 15.9073 10.9605 15.9305C10.9971 15.934 10.855 16.0574 10.7113 16.1821C10.5633 16.3106 10.4136 16.4405 10.4557 16.4425C10.5032 16.4448 10.7803 16.2912 11.0322 16.1517C11.2405 16.0363 11.4315 15.9305 11.4606 15.9305C11.6506 15.9305 11.8222 15.954 11.9727 15.9745C12.2242 16.0089 12.4169 16.0352 12.5381 15.9305C12.5755 15.8983 12.359 15.8464 12.1382 15.7935C11.9108 15.739 11.6788 15.6835 11.7154 15.6472C11.9244 15.4397 11.8371 15.0048 11.7683 14.6623C11.7375 14.5087 11.7103 14.3736 11.7154 14.286C11.7333 13.9749 12.0623 14.1381 12.3209 14.2664C12.4342 14.3225 12.5339 14.372 12.5881 14.372C13.0779 14.372 12.4698 13.7526 12.136 13.4126C12.1067 13.3828 12.0796 13.3551 12.0555 13.3302C11.8857 13.155 12.0048 13.1785 12.2739 13.2317C12.4793 13.2723 12.772 13.3302 13.0905 13.3302C13.8262 13.3302 14.3632 13.0912 14.1766 12.444C14.0536 12.017 13.3797 11.8717 12.6757 11.72C12.3127 11.6417 11.9415 11.5616 11.6338 11.4404C10.8767 11.1419 10.9153 10.7069 10.948 10.339C10.9543 10.2675 10.9605 10.1984 10.9605 10.1335C10.9605 9.73447 11.6338 9.24648 11.6338 9.24648C11.6338 9.24648 11.3265 8.73157 10.8169 8.73157C10.3073 8.73157 10.2597 9.24648 10.2597 9.24648ZM11.6458 13.9324V13.556C11.6458 13.556 11.9605 13.5457 12.0709 13.8104C12.1812 14.0751 11.6458 13.9324 11.6458 13.9324Z",
        fill: "#272727"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.80768 8.03339L10.5679 8.93484L10.9615 8.84225L10.7727 7.93224L9.80768 8.03339Z",
        fill: "#D74800"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.7946 7.81544L10.8436 9.17073L11.4927 9.01101L11.7691 8.12338L10.7946 7.81544Z",
        fill: "#FFD018"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.1827 10.0791C10.3261 10.0791 10.4423 9.96578 10.4423 9.82599C10.4423 9.68619 10.3261 9.57286 10.1827 9.57286C10.0393 9.57286 9.9231 9.68619 9.9231 9.82599C9.9231 9.96578 10.0393 10.0791 10.1827 10.0791Z",
        fill: "#D74800"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.8323 8.06935L11.0766 8.97451L11.2361 9.34612L12.0995 9.00217L11.8323 8.06935Z",
        fill: "#D74800"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.589 14.9198C13.589 14.9198 14.9183 14.326 14.9183 13.4955C14.9183 12.665 12.7598 11.7604 12.7598 11.7604C12.7598 11.7604 11.4901 12.051 12.0624 12.4399C12.6347 12.8287 13.4014 12.9781 13.4014 13.4955C13.4014 14.0128 13.6115 14.5061 13.1856 14.5061C12.7598 14.5061 13.589 14.9198 13.589 14.9198Z",
        fill: "#D74800"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.6711 11.6086C11.6711 11.6086 11.201 11.6912 11.2233 11.7675C11.285 11.9786 11.9279 12.2536 12.208 12.444C12.7803 12.8329 13.3229 12.7892 13.7266 12.5361C14.1303 12.283 11.6711 11.6086 11.6711 11.6086Z",
        fill: "#FFFDFF"
      })]
    })]
  })]
}));
//# sourceMappingURL=Uganda.js.map